import { defineStore } from "pinia";
import RvApi from "@/rvapi";
import type { PromotionCode } from "@/rvapi";

export const usePromotionStore = defineStore("promotions", {
  state: () => ({
    campaignCodes: [] as PromotionCode[],
  }),
  actions: {
    async getCampaigns() {
      const data = await RvApi.getCampaignCodes();
      this.campaignCodes = data.codes;
    },
    async getPricing() {
      return RvApi.getPricing();
    },
    async createCampaign(
      code: string,
      value: number,
      limit: number,
      expireDate: string,
      type: string,
      requireLogin: boolean,
    ) {
      return RvApi.createCampaign(
        code,
        value,
        limit,
        expireDate,
        type,
        requireLogin,
      );
    },
    async createGoodwill(
      codetext: string,
      cardcount: number,
      expireDate: string,
    ) {
      return RvApi.createGoodwill(codetext, cardcount, expireDate);
    },
    async createUnique(
      count: number,
      value: number,
      expireDate: string,
      campaign?: string,
    ) {
      return RvApi.createUnique(count, value, expireDate, campaign);
    },
  },
});
